import moment from "moment";

const TimeFormat = (value: string) => {
    if (!value) {
        return "";
    }

    if (value.includes('GMT')) {
        //const d = new Date(value);
        const d = new Date();
        const val = moment(value).subtract(d?.getTimezoneOffset() * -1, 'minutes').toDate();

        return val.toLocaleTimeString().replace(":00", "");
    }
    else {
        return value
    }
}

export default TimeFormat